import { FC, useCallback, useState } from "react";
import { CommitmentUtilizationType } from "@/services/cloudchipr.api";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { commitmentUtilizationSetupPropertyByKeySelector } from "@/store/dashboards/selectors/setups/commitment-utilization/commitmentUtilizationSetupPropertyByKeySelector";
import { commitmentUtilizationWidgetSetupDataChangeThunk } from "@/store/dashboards/thunks/widgets/commitment-utilization/setup-change/commitmentUtilizationWidgetSetupDataChangeThunk";
import { CommitmentUtilizationWidgetTypeSelect } from "@/components/pages/dashboard/components/widgets/commitment-utlization/components/CommitmentUtilizationWidgetTypeSelect";

export const CommitmentUtilizationWidgetSetupTypeSelect: FC = () => {
  const dispatch = useAppDispatch();

  const commitmentType: CommitmentUtilizationType = useAppSelector(
    commitmentUtilizationSetupPropertyByKeySelector("commitmentType"),
  );
  const [commitmentTypes, setCommitmentTypes] = useState<
    CommitmentUtilizationType[]
  >(commitmentType === "all" ? allOption : [commitmentType]);

  const handleChange = useCallback(
    (value: CommitmentUtilizationType[]) => {
      if (!value?.length) {
        setCommitmentTypes([...allOption]);
        commitmentUtilizationWidgetSetupDataChangeThunk({
          commitmentType: "all",
        });
        return;
      }

      const commitmentType = value.length === 1 ? value.at(0) : "all";

      if (!commitmentType) {
        return;
      }

      setCommitmentTypes(value);
      dispatch(
        commitmentUtilizationWidgetSetupDataChangeThunk({ commitmentType }),
      );
    },
    [dispatch],
  );

  return (
    <CommitmentUtilizationWidgetTypeSelect
      onChange={handleChange}
      commitmentTypes={commitmentTypes}
    />
  );
};

const allOption: CommitmentUtilizationType[] = ["savings_plan", "reservation"];
